/* eslint-disable no-unused-vars */
enum ArmorType {
  ALL = 0,
  BLADEMASTER = 1,
  GUNNER = 2,
}

export default ArmorType
